import PropTypes from 'prop-types';
import React from 'react';
import { withI18n } from 'lingui-react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';

import {
  addPageToBreadcrumbs,
  setLoadingStarted,
} from 'redux/app/actions';
import {
  loadAsset,
  setCurrentAsset,
  setCurrentAssetCases,
} from 'redux/assets/actions';
import {
  currentAssetSelector,
  loadAssetErrorSelector,
} from 'redux/assets/selectors';

import immutableToJS from 'utils/immutableToJS';

import Component from './Component';

/* istanbul ignore next */
const withAssetDetailData = (DetailsPage) => {
  function WithAssetDetailData(props) {
    return (
      <Component {...props} ChildComponent={DetailsPage} />
    );
  }

  WithAssetDetailData.propTypes = {
    addPageToBreadcrumbs: PropTypes.func.isRequired,
    assetError: PropTypes.shape({
      error: PropTypes.oneOf([true]).isRequired,
    }),
    assetInfo: PropTypes.shape({
      id: PropTypes.string,
    }).isRequired,
    // This component doesn't care what is in componentProps, only that it is an object.
    // eslint-disable-next-line react/forbid-prop-types
    componentProps: PropTypes.object.isRequired,
    i18n: PropTypes.shape({
      _: PropTypes.func.isRequired,
    }).isRequired,
    loadAsset: PropTypes.func.isRequired,
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
    }).isRequired,
    match: PropTypes.shape({
      params: PropTypes.shape({
        assetId: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    setCurrentAsset: PropTypes.func.isRequired,
    setCurrentAssetCases: PropTypes.func.isRequired,
    setLoadingStarted: PropTypes.func.isRequired,
  };

  WithAssetDetailData.defaultProps = {
    assetError: undefined,
  };

  function mapStateToProps(state) {
    return {
      assetError: loadAssetErrorSelector(state),
      assetInfo: currentAssetSelector(state),
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      addPageToBreadcrumbs: breadcrumbs => dispatch(addPageToBreadcrumbs(breadcrumbs)),
      loadAsset: assetId => dispatch(loadAsset({ assetId })),
      setCurrentAsset: assetId => dispatch(setCurrentAsset(assetId)),
      setCurrentAssetCases: assetCases => dispatch(setCurrentAssetCases(assetCases)),
      setLoadingStarted: () => dispatch(setLoadingStarted(true)),
    };
  }

  return compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    withI18n(),
    immutableToJS,
  )(WithAssetDetailData);
};

export default withAssetDetailData;



// WEBPACK FOOTER //
// ./containers/AssetDetailData/index.js